import React from "react"
import Navbar from "../../../Common/Components/Navbar"
import Footer from "../../../Common/Components/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import AddTransactionComp  from "./Component/AddTransactionComp"

const AddTransaction =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <AddTransactionComp />
        </div>
        <Footer />
        </>
    )
}

export default AddTransaction